import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import Drawer from '../Drawer';
import { drawerIconOffset } from '../../../shared-variables';

/*
NOTE: All drawers mirror each other in design, with the only difference
being the offset.
*/
var SearchDrawer = function (_PureComponent) {
  _inherits(SearchDrawer, _PureComponent);

  function SearchDrawer() {
    _classCallCheck(this, SearchDrawer);

    return _possibleConstructorReturn(this, (SearchDrawer.__proto__ || _Object$getPrototypeOf(SearchDrawer)).apply(this, arguments));
  }

  _createClass(SearchDrawer, [{
    key: 'render',
    value: function render() {
      return React.createElement(Drawer, _extends({
        iconOffset: drawerIconOffset,
        width: this.props.isFullWidth ? 'full' : 'wide'
      }, this.props));
    }
  }]);

  return SearchDrawer;
}(PureComponent);

export default SearchDrawer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/drawers/SearchDrawer.js
// module id = 726
// module chunks = 0